/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import BSCol from "react-bootstrap/Col";
import BSRow from "react-bootstrap/Row";
import BSTab from "react-bootstrap/Tab";
import BSTabs from "react-bootstrap/Tabs";
import Flag from "react-flags";
import {noWhitespace} from "tempura";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class AuctionInformationTabs extends Component {
  static propTypes = {
    // Base URL for static assets.
    assetsUrl: PropTypes.string.isRequired,

    // The location of the auction.
    auctionLocation: PropTypes.shape({
      address: PropTypes.array.isRequired,
      city: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      region: PropTypes.string.isRequired,
    }),

    // The CC2 code for the country of the organization.
    countryCC2: PropTypes.string.isRequired,

    // The organisation country.
    countryName: PropTypes.string.isRequired,

    // The description associated with the auction.
    description: PropTypes.string.isRequired,

    shipping: PropTypes.string.isRequired,

    // The taxes associated with this auction.
    taxes: PropTypes.array.isRequired,

    // The terms associated with this auction.
    terms: PropTypes.string.isRequired,
  };

  static contextTypes = {
    __: PropTypes.func.isRequired,
  };

  render() {
    const {__} = this.context;
    const {
      assetsUrl,
      countryCC2,
      countryName,
      description,
      auctionLocation,
      shipping,
      taxes,
      terms,
    } = this.props;

    return (
      <BSTabs defaultActiveKey="tab-description" id="auction-information">
        <BSTab
          eventKey="tab-description"
          title={__("auction::catalog.description")}
        >
          {description ? (
              <div
                dangerouslySetInnerHTML={{__html: description}}
              />
            ) : (
              <div>
                <em>
                  {__("general::noDescription")}
                </em>
              </div>
            )
          }
        </BSTab>
        <BSTab
          eventKey="tab-location"
          title={__("auction::catalog.location")}
        >
          <BSRow>
            <BSCol md={4}>
              <address>
                {auctionLocation.address[0] || null}
                {auctionLocation.address[1] || null}
                <br />
                {auctionLocation.city},
                <br />
                {auctionLocation.region},
                {` ${auctionLocation.postalCode}`}
                <br />
                {`${countryName} `}
                <Flag
                  country={countryCC2}
                  pngSize={16}
                  shiny
                  basePath={`${assetsUrl}/img/flags`}
                />
              </address>
            </BSCol>
            <BSCol md={8}>
              <div className="flexible-container">
                <iframe
                  width={600}
                  height={450}
                  frameBorder={0}
                  style={{border: 0}}
                  src={noWhitespace`
                    https://www.google.com/maps/embed/v1/place?key=AIzaSyDY1d5SL506REZ3LnIbs-uDwJrTatajxig
                    &q=${auctionLocation.address[0]}
                    ${auctionLocation.address[1] ?
                      `+${auctionLocation.address[1]}` : "" }
                    +${auctionLocation.city}
                    +${auctionLocation.region}
                    +${auctionLocation.postalCode}
                    +${countryName}
                    &zoom=10
                  `}
                >
                </iframe>
              </div>
            </BSCol>
          </BSRow>
        </BSTab>
        {taxes.length ? (
          <BSTab
            eventKey="tab-taxes"
            title={__("general::taxes")}
          >
          {__("general::taxes")}
          </BSTab>
        ) : null}
        {shipping ? (
          <BSTab
            eventKey="tab-shipping"
            title={__("general::shipping")}
          >
            <div
              dangerouslySetInnerHTML={{__html: shipping}}
            />
          </BSTab>
        ) : null}
        {terms ? (
          <BSTab
            eventKey="tab-terms"
            title={__("general::terms")}
          >
            <div
              dangerouslySetInnerHTML={{__html: terms}}
            />
          </BSTab>
        ) : null}
      </BSTabs>
    );
  }
}



// WEBPACK FOOTER //
// ../components/AuctionInformationTabs.jsx